import { render } from "./p-search-screen.vue?vue&type=template&id=9668f3f2&scoped=true"
import script from "./p-search-screen.vue?vue&type=script&lang=js"
export * from "./p-search-screen.vue?vue&type=script&lang=js"

import "./p-search-screen.vue?vue&type=style&index=0&id=9668f3f2&scoped=true&lang=scss"
import "./p-search-screen.vue?vue&type=style&index=1&id=9668f3f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9668f3f2"]])

export default __exports__